export default __webpack_public_path__ + "static/media/make-it-rain-kim.4d507c85.gif";